<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigil_not_in_toc" id="pgepubid00000"><a class="calibre1" id="MAX_CARRADOS">MAX CARRADOS</a></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec001_split_000.vue?c59fc7b8